<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="gastos"
      item-key="id"
      :sort-by="[{ key: 'fecha', order: 'desc' }]"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Gastos</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn color="primary" variant="flat" @click="openDialogForNew">
            Nuevo Gasto
          </v-btn>
        </v-toolbar>
        <v-row class="px-4 pb-2" dense>
          <v-col cols="12" md="3">
            <v-select
              v-model="filtros.categoria_gasto_id"
              :items="categoriasGasto"
              item-title="descripcion"
              item-value="id"
              label="Categoría"
              clearable
              density="compact"
              @update:model-value="recargar"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="filtros.fecha_inicio"
              label="Desde"
              type="date"
              density="compact"
              @update:model-value="recargar"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="filtros.fecha_fin"
              label="Hasta"
              type="date"
              density="compact"
              @update:model-value="recargar"
            />
          </v-col>
        </v-row>
      </template>

      <template v-slot:[`item.fecha`]="{ item }">
        {{ moment(item.fecha).format('DD/MM/YYYY') }}
      </template>

      <template v-slot:[`item.categoria`]="{ item }">
        {{ item.categoria_gasto?.descripcion }}
      </template>

      <template v-slot:[`item.auto`]="{ item }">
        <span v-if="item.auto">{{ item.auto.placa }}</span>
        <span v-else class="text-grey">—</span>
      </template>

      <template v-slot:[`item.monto`]="{ item }">
        <v-chip color="primary" size="small">S/ {{ Number(item.monto).toFixed(2) }}</v-chip>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-icon class="me-2" size="small" @click="editItem(item)">mdi-pencil</v-icon>
        <v-icon size="small" color="red" @click="confirmDelete(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>

    <GastoDialog
      :dialog="dialog"
      :editedItem="editedItem"
      :formTitle="formTitle"
      :categoriasGasto="categoriasGasto"
      :autos="autos"
      @update:dialog="dialog = $event"
      @save="saveDialog"
    />

    <v-dialog v-model="dialogDelete" width="auto" persistent>
      <v-card max-width="400" prepend-icon="mdi-delete" title="Eliminar Gasto"
        text="¿Está seguro de eliminar este gasto?">
        <template v-slot:actions>
          <v-spacer />
          <v-btn color="blue-darken-1" text @click="dialogDelete = false">Cancelar</v-btn>
          <v-btn color="red-darken-1" text @click="deleteItemConfirm">Eliminar</v-btn>
        </template>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';
import GastoDialog from '@/components/gasto/GastoDialog.vue';

export default {
  components: { GastoDialog },
  data() {
    return {
      moment,
      dialog: false,
      dialogDelete: false,
      headers: [
        { title: 'Fecha', value: 'fecha' },
        { title: 'Categoría', value: 'categoria' },
        { title: 'Descripción', value: 'descripcion' },
        { title: 'Auto', value: 'auto' },
        { title: 'Monto', value: 'monto' },
        { title: 'Acciones', value: 'actions', sortable: false },
      ],
      editedIndex: -1,
      editedItem: {},
      filtros: {
        categoria_gasto_id: null,
        fecha_inicio: '',
        fecha_fin: '',
      },
    };
  },
  computed: {
    ...mapGetters('gasto', ['gastos', 'categoriasGasto', 'autos']),
    formTitle() {
      return this.editedIndex === -1 ? 'Nuevo Gasto' : 'Editar Gasto';
    },
  },
  created() {
    this.recargar();
    this.fetchCategoriasGasto();
    this.fetchAutosForGasto();
  },
  methods: {
    ...mapActions('gasto', [
      'fetchGastos',
      'getGastoById',
      'guardarGasto',
      'updateGasto',
      'deleteGasto',
      'fetchCategoriasGasto',
      'fetchAutosForGasto',
    ]),
    recargar() {
      const params = {};
      if (this.filtros.categoria_gasto_id) params.categoria_gasto_id = this.filtros.categoria_gasto_id;
      if (this.filtros.fecha_inicio) params.fecha_inicio = this.filtros.fecha_inicio;
      if (this.filtros.fecha_fin) params.fecha_fin = this.filtros.fecha_fin;
      this.fetchGastos(params);
    },
    openDialogForNew() {
      this.editedItem = {};
      this.editedIndex = -1;
      this.dialog = true;
    },
    async editItem(item) {
      const gasto = await this.getGastoById(item.id);
      this.editedItem = {
        id: gasto.id,
        categoria_gasto_id: gasto.categoria_gasto_id,
        auto_id: gasto.auto_id,
        fecha: gasto.fecha?.slice(0, 10),
        descripcion: gasto.descripcion,
        monto: Number(gasto.monto),
        comprobante: gasto.comprobante || '',
      };
      this.editedIndex = this.gastos.findIndex(g => g.id === item.id);
      this.dialog = true;
    },
    confirmDelete(item) {
      this.editedItem = { ...item };
      this.dialogDelete = true;
    },
    async deleteItemConfirm() {
      await this.deleteGasto(this.editedItem.id);
      this.dialogDelete = false;
    },
    async saveDialog(item) {
      const action = this.editedIndex === -1 ? this.guardarGasto : this.updateGasto;
      await action(item);
      this.dialog = false;
      this.recargar();
    },
  },
};
</script>
